/**
 *
 * @returns {{schedIn1: string, schedOut1: string, schedIn2: string, schedOut2: string}}
 */
function getSchedule({
  workHours: { am_in, am_out, pm_in, pm_out },
  shifts: { shf_in1, shf_out1, shf_in2, shf_out2 }
}) {
  const schedule = {
    schedIn1: am_in,
    schedOut1: am_out,
    schedIn2: pm_in,
    schedOut2: pm_out
  };

  if (shf_in1 && shf_out1) {
    schedule.schedIn1 = shf_in1;
    schedule.schedOut1 = shf_out1;
  }

  if (shf_in2 && shf_out2) {
    schedule.schedIn2 = shf_in2;
    schedule.schedOut2 = shf_out2;
  }

  return schedule;
}

export default getSchedule;
